import React from 'react';

import { LayoutCharts } from '../../charts/layout/LayoutCharts';

import useManageHome from '../hooks/useManageHome';

import { setSessionStateActionsPending } from '../../../redux/actions/sessionState';

export const LayoutHome = () => {
    const {
        configuration
    } = useManageHome();

    return (
        <>
            {configuration &&
                <LayoutCharts
                    conf={configuration}
                />
            }
        </>
        // // <Box sx={{ width: '100%' }}>
        // //     <Box sx={{ mb: 2, pt: 2, pl: 2, pr: 2 }}>
        // <Breadcrumbs
        //             aria-label="breadcrumb"
        //             separator="›"
        //             sx={{ mb: 2 }}
        //         >
        //             <Link
        //                 underline="hover"
        //                 color="text.main"
        //                 sx={{ cursor: 'pointer' }}
        //                 onClick={() => validateChangesPending('/settings')}
        //             >
        //                 <Typography
        //                     sx={{ fontWeight: pathnames.length === 0 && "bold" }}
        //                 >
        //                     Home
        //                 </Typography>
        //             </Link>

        //         </Breadcrumbs> */}

        // //     </Box>
        // // </Box >
    )

}